import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { getFullLocale } from '../services/i18n';
import type { SupportedLocale } from '../types';

const ROUTE_LOCALES: Record<string, SupportedLocale> = {
  en: 'en-GB',
  it: 'it-IT',
  es: 'es-ES',
  fr: 'fr-FR',
  de: 'de-DE'
};

/**
 * Hook to get the correct locale format for API calls
 * i18next uses short codes (en, it, es) but API expects full locales (en-GB, it-IT, es-ES)
 */
export const useApiLocale = (): SupportedLocale => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const routeLocale = ROUTE_LOCALES[location.pathname.split('/')[1]];
  if (routeLocale) {
    return routeLocale;
  }

  const currentShortCode = i18n.language || 'en';
  return getFullLocale(currentShortCode);
};
